// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__2MhwO","footer":"ModalInfo_footer__2vrPS"};